import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ApiService from "@/common/API.service";
import { ModalPlugin } from "bootstrap-vue";
import VueQuillEditor from "vue-quill-editor";
import rtdb from "@/plugins/rtdb";
import * as Sentry from "@sentry/vue";
import AskAiPlugin from "@/plugins/ask-ai";

// css
import "@/assets/css/tailwind.scss";
import "sweetalert2/dist/sweetalert2.min.css";

// 3td party
import VueSweetalert2 from "vue-sweetalert2";
import VueCrontab from "vue-crontab";
import ShortKey from "vue-shortkey";

Vue.use(ModalPlugin);
Vue.use(VueCrontab);
Vue.use(VueSweetalert2);
Vue.use(ShortKey);
Vue.use(VueQuillEditor);
Vue.use(rtdb);
Vue.use(AskAiPlugin, { store });

Vue.config.productionTip = false;

ApiService.init();

// --- @todo for debugging only, akan dihapus jika dirasa aman
const paths = ["/agent", "/panel", "/auth"];
const isStaff = paths.some((path) => window.location.pathname.startsWith(path));
if (isStaff) {
  Sentry.init({
    Vue,
    dsn: "https://c5b304abd833287f8b382d5291e21829@o4511352007557120.ingest.us.sentry.io/4511352009719808",
    sendDefaultPii: true,
    tracesSampleRate: 0,
    logErrors: true,
    attachProps: true,
  });

  Vue.config.errorHandler = function (err, vm, info) {
    Sentry.captureException(err, {
      extra: {
        info: info,
        component: vm?.$options?.name,
        route: vm?.$route?.fullPath,
        agent: localStorage.getItem("rw:agent"),
      },
    });
  };
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
